import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import colors from '@src/theme/chakraTheme/colors';
import { ADDRESS, EMAIL, PHONE_NUMBER } from '@src/commons/constants';

export default [
  {
    icon: (
      <FontAwesomeIcon
        icon={faEnvelope}
        color={colors.colors.secondary}
        size="sm"
        height={16}
      />
    ),
    text: EMAIL,
  },
  {
    icon: (
      <FontAwesomeIcon
        icon={faPhone}
        color={colors.colors.secondary}
        transform={{ rotate: 100 }}
        size="sm"
        height={16}
      />
    ),
    text: PHONE_NUMBER,
  },
  {
    icon: (
      <FontAwesomeIcon
        icon={faMapMarkerAlt}
        color={colors.colors.secondary}
        size="sm"
        height={16}
      />
    ),
    text: ADDRESS,
  },
];
